export default "__VITE_ASSET__B3EuG4_b__"